import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RmService } from '../../../services/rm/rm.service';

@Component({
  selector: 'app-rm-login',
  templateUrl: './rm-login.component.html',
  styleUrls: ['./rm-login.component.scss']
})
export class RmLoginComponent implements OnInit {
  email = '';
  password = '';
  loading = false;
  errorMessage = '';
  returnUrl = '/rm/dashboard';

  constructor(
    private rmService: RmService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (this.rmService.isLoggedIn()) {
      this.router.navigate(['/rm/dashboard']);
      return;
    }
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/rm/dashboard';
  }

  onSubmit(): void {
    if (!this.email || !this.password) {
      this.errorMessage = 'Please enter both email and password';
      return;
    }
    this.loading = true;
    this.errorMessage = '';

    this.rmService.login(this.email, this.password).subscribe({
      next: res => {
        this.loading = false;
        if (res.status === 'success') {
          this.router.navigateByUrl(this.returnUrl);
        } else {
          this.errorMessage = res.message || 'Login failed. Please verify credentials.';
        }
      },
      error: err => {
        this.loading = false;
        this.errorMessage = err.error?.message || err.message || 'Login failed due to server error.';
      }
    });
  }
}
